export enum TrackingEvent {
  UserRedirected = 'User redirected',
}
